var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backdrop_blur"},[_c('div',{staticClass:"container_background",style:({
      'background-image': _vm.backgroundImage,
    })},[_c('div',{staticClass:"blur_filter"})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideMainApp),expression:"!hideMainApp"}],staticClass:"container_page",attrs:{"transition":"fade-transition"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }